import React, {useEffect, useState} from "react";
import {notification, Spin, Steps} from "antd";
import StepOneComponent from "./StepOne";
import StepTwoComponent from "./StepTwo";
import {CalcData} from "../../model/clases/CalcData";
import StepThree from "./StepThree";
import {api} from "../../core/api";
import Loading from "../../model/enums/Loading";
import {useHistory} from "react-router";
import {CloseCircleOutlined, ExclamationCircleOutlined} from "@ant-design/icons/lib";


const {Step} = Steps;
const moment = require('moment');
const Stepper = () => {
  const [current, setCurrent] = useState<number>(0);
  const [formData, setFormData] = useState<CalcData>(new CalcData());
  const [loading, setLoading] = useState<Loading>(Loading.LOADED);
  const [data, setData] = useState<any>();
  const [receipt, setReceipt] = useState<FormData>(new FormData());
  const [receiptImg, setReceiptImg] = useState<any>();
  const [photo, setPhoto] = useState<any>();
  const [consent, setConsent] = useState<any>(false);

  const openNotification = (message: string) => {
    notification.info({
      message: "Greška!",
      icon: <CloseCircleOutlined color={"red"}/>,
      description: message,
      placement: 'topRight',
    });
  };


  const prev = () => {
    setCurrent(current - 1);
  };
  const next = () => {
    current < steps.length - 1 && setCurrent(current + 1);
  };
  const history = useHistory();
  useEffect(() => {
  }, [receipt]);

  async function createCalc(values: CalcData) {
    try {
      setLoading(Loading.LOADING);
      let response = await api.create.create(values);
      if(response.data.controlError){
        console.log(response.data.controlError);
        openNotification(response.data.controlError);
        setLoading(Loading.LOADED);
        return false;
      }
      setData(response.data);

      next();
      setLoading(Loading.LOADED);
    } catch (e) {
      setLoading(Loading.LOADED);
    }
  }

  async function handleUpload(values: CalcData) {
    console.log(values);
    let uploadData = receipt;
    values.receipt && uploadData.append("receipt", values.receipt);
    values.receipt && uploadData.append("mime", values.receipt.type);
    values.receipt && uploadData.append("name", values.receipt.name);
    //@ts-ignore
    uploadData.append("calc", values.calc);
    values.no1 && uploadData.append("premium", values.no1.toString());
    values.startDate && uploadData.append("date_from", moment(values.startDate).format('YYYY-MM-DD HH:mm:ss'));
    uploadData.append("itemType", values.itemType);
    //@ts-ignore
    uploadData.append("c_jmbg", values.cRegno);
    //@ts-ignore
    uploadData.append("i_jmbg", values.iRegno);
    uploadData.append("insuranceValue", values.accident);
    values.purchaseDate && uploadData.append("purchaseDate", moment(values.purchaseDate).format('YYYY-MM-DD HH:mm:ss'));
    values.itemValue && uploadData.append("itemValue", values.itemValue.toString());
    values.cFirstName && uploadData.append("c_first_name", values.cFirstName);
    values.cLastName && uploadData.append("c_last_name", values.cLastName);
    values.cAddress && uploadData.append("c_address", values.cAddress);
    values.cCity && uploadData.append("c_city", values.cCity);
    values.phone && uploadData.append("c_phone", values.phone);
    values.email && uploadData.append("c_email", values.email);
    uploadData.append("receive_news", consent);
    values.iFirstName && uploadData.append("i_first_name", values.iFirstName);
    values.iLastName && uploadData.append("i_last_name", values.iLastName);
    values.iAddress && uploadData.append("i_address", values.iAddress);
    values.iCity && uploadData.append("i_city", values.iCity);
    values.photo && uploadData.append("photo", photo);


    setReceipt(uploadData);

    //@ts-ignore
    await api.upload.create(uploadData);
    /*console.log(URL.createObjectURL(values.receipt));
    console.log(URL.createObjectURL(uploadData));*/
  }

  async function updateCalc(values: CalcData) {
    let resource = {...formData, ...values, calc: data.calc, no1: data.total};
    try {
      setLoading(Loading.LOADING);
      let response = await api.update.update(resource);
      let newData = {...data, ...response.data};
      setData(newData);

      next();
      setLoading(Loading.LOADED);
    } catch (e) {
      console.log(e)
    }
  }

  async function closeCalc(values: CalcData) {
    let resource = {...formData, ...values, calc: data.calc, no1: data.total};
    try {
      setLoading(Loading.LOADING);
      try {
        await handleUpload(resource);
      } catch (e) {
        console.error(e)
      }
      let response = await api.close.close(resource);
      let newData = {...data, ...response.data};
      setData(newData);
      next();
      setLoading(Loading.LOADED);
      history.push({pathname: '/payment', state: response.data})
    } catch (e) {
      console.log(e)
    }
  }

  const handleLoader = (value: Loading) => {
    setLoading(value)
  };
  const onFinish = (values: CalcData) => {
    setFormData({...formData, ...values});
    current === 0  ? createCalc(values) : updateCalc(values);

  };

  const handleFinish = (values: CalcData) => {
    setFormData({...formData, ...values});
    closeCalc(values)
  };
  const steps = [
    {
      content:
        <Spin spinning={loading === "LOADING"} style={{position: "fixed"}}>
          <StepOneComponent
            next={next}
            onFinish={(values: any) => onFinish(values)}
            current={current}
            steps={3}
            initialData={formData}
            isHull={!!formData.hull}
            onReceiptChange={(e: any) => {
              setReceiptImg(e.target.files[0]);
            }
            }
          />
        </Spin>,
    },
    {
      content:
        <Spin spinning={loading === "LOADING"} style={{position: "fixed"}}>
          <StepTwoComponent
            calcData={formData}
            prev={prev}
            next={next}
            steps={3}
            onFinish={(values: any) => onFinish(values)}
            current={current}
            initial={formData}
            price={data?.total}
            data={data}
          />
        </Spin>,
    },
    {
      content:
        <Spin spinning={loading === "LOADING"} style={{position: "fixed"}}>
          <StepThree
            prev={prev}
            next={next}
            steps={3}
            handleFinish={(values: any) => handleFinish(values)}
            current={current}
            initial={formData}
            calc={data && data.calc}
            handleConsent={(e)=>setConsent(e)}
            handleLoader={handleLoader}
            onPhoto={(e: any) => {
              setPhoto(e);
            }
            }
          />
        </Spin>,
    },
  ];


  return (
    <div className={"step-window"}>
      <div style={{display: "flex", justifyContent: "space-evenly", maxWidth: 700, margin: "auto"}}>
        <div className={"step-title " + (current !== 0 && "step-title-inactive")}>Unos Podataka</div>
        <div className={"step-title " + (current !== 1 && "step-title-inactive")}>Obračun</div>
        <div className={"step-title " + (current !== 2 && "step-title-inactive")}>Zaključivanje</div>
      </div>
      <Steps
        current={current}
        //onChange={(e) => onChange(e)}
      >
        {steps.map((item, no) => (
          <Step key={no + "step"} status={no < current ? "wait" : no > current ? "wait" : "process"}/>
        ))}
      </Steps>
      <div>{steps[current].content}</div>
    </div>
  )
};

export default Stepper;
